import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana26Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
   <rect width="1221" height="926" fill="url(#pattern0_1468_40228)"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M268.983 527.609L304.068 516.529L324.38 586.699L259.75 607.011L268.983 527.609Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}       
      d="M355.776 498.063L304.072 516.529L324.385 586.699L379.782 568.233L355.776 498.063Z" 
      fill={getFillByLot(2, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}       
      d="M405.631 479.598L355.773 498.063L379.779 568.233L433.329 551.614L405.631 479.598Z" 
      fill={getFillByLot(3, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}       
      d="M486.882 529.457L433.331 551.616L405.633 479.599L457.337 459.287L486.882 529.457Z" 
      fill={getFillByLot(4, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}       
      d="M505.345 437.128L457.334 459.287L486.879 529.457L538.583 505.451L505.345 437.128Z" 
      fill={getFillByLot(5, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}       
      d="M555.203 414.967L505.346 437.126L538.584 505.449L588.441 483.29L555.203 414.967Z" 
      fill={getFillByLot(6, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("19"))}       
      d="M257.905 634.711L259.752 607.013L316.996 588.547L342.848 658.717L300.376 671.643L257.905 634.711Z" 
      fill={getFillByLot(19, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("18"))}       
      d="M401.941 640.251L342.851 658.717L316.999 588.547L374.243 570.081L401.941 640.251Z" 
      fill={getFillByLot(18, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("17"))}       
      d="M459.175 618.09L401.931 640.249L374.232 570.079L431.476 551.613L459.175 618.09Z" 
      fill={getFillByLot(17, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("16"))}       
      d="M516.425 595.932L459.181 618.091L431.482 551.614L486.88 529.455L516.425 595.932Z" 
      fill={getFillByLot(16, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("15"))}       
      d="M577.37 568.232L516.433 595.93L486.888 529.454L540.438 503.602L577.37 568.232Z" 
      fill={getFillByLot(15, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("14"))}       
      d="M630.908 540.535L577.357 568.233L540.426 503.603L597.67 479.598L630.908 540.535Z" 
      fill={getFillByLot(14, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}       
      d="M603.213 390.961L555.202 414.966L588.44 483.29L638.298 455.591L603.213 390.961Z" 
      fill={getFillByLot(7, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}       
      d="M653.071 363.263L603.214 390.961L638.299 455.591L688.156 429.739L653.071 363.263Z" 
      fill={getFillByLot(8, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}       
      d="M664.153 357.726L653.073 363.265L688.158 429.742L780.487 383.578L664.153 357.726Z" 
      fill={getFillByLot(9, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("10"))}       
      d="M854.352 398.351L780.489 383.578L762.023 392.811L793.415 453.748L856.199 422.356C863.585 409.061 858.661 401.428 854.352 398.351Z" 
      fill={getFillByLot(10, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("13"))}       
      d="M686.31 510.99L630.913 540.535L597.675 479.598L653.072 448.206L686.31 510.99Z" 
      fill={getFillByLot(13, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("12"))}       
      d="M739.862 483.289L686.312 510.988L653.073 448.204L706.624 420.506L739.862 483.289Z" 
      fill={getFillByLot(12, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("11"))}       
      d="M793.416 453.746L739.865 483.292L706.627 420.508L762.024 392.81L793.416 453.746Z" 
      fill={getFillByLot(11, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1468_40228" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1468_40228" transform="matrix(0.00253288 0 0 0.00333979 -4.47099 -1.23168)"/>
    </pattern>
    <image id="image0_1468_40228" width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};